import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/common/PageHeader";
import { StatCard } from "@/components/common/StatCard";
import { DataTable } from "@/components/common/DataTable";
import { Banknote, Factory, CreditCard } from "lucide-react";
import { formatCurrency } from "@/lib/currency";

export default function CommercialPage() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/v1/admin/commercial").then((r) => setData(r.data.data)).catch(() => {}); }, []);
  const packs = Object.entries(data?.industryPackAdoption || {}).map(([k, v]) => ({ pack: k, count: v }));

  return (
    <div data-testid="commercial-page">
      <PageHeader title="Commercial Control Center" subtitle="Revenue, plan & industry-pack adoption" />
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-7">
        <StatCard testid="stat-revenue" label="Monthly Revenue (placeholder)" value={formatCurrency(data?.revenuePlaceholderMonthly || 0)} icon={Banknote} accent="text-emerald-500" />
        <StatCard testid="stat-plans" label="Active Plans" value={(data?.plans || []).length} icon={CreditCard} />
        <StatCard testid="stat-packs" label="Pack Assignments" value={packs.reduce((a, b) => a + b.count, 0)} icon={Factory} accent="text-violet-500" />
      </div>
      <div className="grid lg:grid-cols-2 gap-6">
        <div>
          <h3 className="font-semibold text-slate-800 mb-3">Plan Pricing</h3>
          <DataTable testid="commercial-plans-table" rows={data?.plans || []} loading={!data}
            columns={[
              { key: "planName", header: "Plan" },
              { key: "tier", header: "Tier" },
              { key: "price", header: "Price", render: (p) => p.price ? formatCurrency(p.price) : "Custom" },
            ]} />
        </div>
        <div>
          <h3 className="font-semibold text-slate-800 mb-3">Industry Pack Adoption</h3>
          <DataTable testid="commercial-packs-table" rows={packs} loading={!data} empty="No packs assigned yet"
            columns={[{ key: "pack", header: "Pack" }, { key: "count", header: "Tenants" }]} />
        </div>
      </div>
    </div>
  );
}
